import _ from 'lodash';
import { BrowserTracing } from '@sentry/tracing';

const config = {};

if (process.env.NODE_ENV === 'production') {
  config.serverUrl = `${location.protocol}//${window.location.hostname}`;
  if (process.env.REACT_APP_BLAZE_PORT) {
    config.serverUrl += `:${process.env.REACT_APP_BLAZE_PORT}`;
  }
} else {
  const WWW_PORT = process.env.REACT_APP_BLAZE_PORT || '1337';
  if (location.protocol === 'https:') {
    config.serverUrl = `${location.protocol}//${window.location.hostname}`;
  } else {
    config.serverUrl = `${location.protocol}//${window.location.hostname}:${WWW_PORT}`;
  }
}

config.apiUrl = `${config.serverUrl}/api`;

// Ref asset from public directory
config.publicUrl = assetUrl => `${process.env.PUBLIC_URL}/${assetUrl}`;
config.google = {
  mapsKey: 'AIzaSyCV47YON9b0ySx4AamSM9FBuDuUUzH9s0I',
};

config.sentry = {
  integrations: [new BrowserTracing()],
  dsn:
    process.env.NODE_ENV !== 'development' || process.env.REACT_APP_USE_SENTRY
      ? 'https://0a0c1959bacf4cf6944cc6f200289908@o20415.ingest.sentry.io/6677800'
      : null,
  beforeSend: event => {
    const exceptionMessage = _.get(event, 'exception.values[0].value');

    // don't send these to sentry
    const ignore = ['Network Error', 'Request failed with status code 401'];

    if (ignore.includes(exceptionMessage)) {
      return null;
    }

    return event;
  },
};

export default config;
